import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICreateMerchantRequest } from 'src/app/domain/registration/models/merchants/ICreateMerchantRequest';
import { ICreateMerchantResponse } from 'src/app/domain/registration/models/merchants/ICreateMerchantResponse';
import { IMerchant } from 'src/app/domain/registration/models/merchants/IMerchant';
import { AbstractCrudService } from 'src/app/shared/components/crud/abstract-crud.service';
import { API_PATH, IBGE_API_PATH } from 'src/environments/environment';
import { MerchantFilter, RELATIVE_URL } from './crud-config';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class MerchantService extends AbstractCrudService {
    constructor(
        protected override httpClient: HttpClient
    ) {
        super(
            httpClient, RELATIVE_URL
        );
    }

    createMerchant(request: ICreateMerchantRequest): Observable<ICreateMerchantResponse> {
        return this.httpClient.post<ICreateMerchantResponse>(`${API_PATH}${this.relativeUrl}`, request);
    }

    getAllMerchants(
        filters?: MerchantFilter,
        syncCanvi?: boolean
    ): Observable<IMerchant[]> {

        let params = new HttpParams();

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value !== null && value !== undefined && value !== '') {
                    params = params.set(key, String(value));
                }
            });
        }

        if (syncCanvi !== undefined) {
            params = params.set('syncCanvi', String(syncCanvi));
        }

        return this.httpClient.get<IMerchant[]>(
            `${API_PATH}${this.relativeUrl}`,
            { params }
        );
    }


    getMerchantById(id: string): Observable<IMerchant> {
        return this.httpClient.get<IMerchant>(`${API_PATH}${this.relativeUrl}/${id}`);
    }

    findById(id: string): Observable<IMerchant> {
        return this.getMerchantById(id);
    }

    getMerchantByDocument(documentNumber: string): Observable<IMerchant> {
        return this.httpClient.get<IMerchant>(`${API_PATH}${this.relativeUrl}/document/${documentNumber}`);
    }

    getMerchantByPartnerId(partnerId: string): Observable<IMerchant> {
        return this.httpClient.get<IMerchant>(`${API_PATH}${this.relativeUrl}/partner/${partnerId}`);
    }

    setDefaultPixKey(pixKeyId: string): Observable<{ message: string }> {
        return this.httpClient.patch<{ message: string }>(
            `${API_PATH}${this.relativeUrl}/pix-keys/${pixKeyId}/set-default`,
            {}
        );
    }

    getCepInfo(cep: string): Observable<any> {
        return this.httpClient.get<any>(`${API_PATH}customers/cep/${cep}`);
    }

    getCitiesByUf(uf: string): Observable<any> {
        return this.httpClient.get(`${IBGE_API_PATH}localidades/estados/${uf}/municipios`);
    }

    getStates(): Observable<any[]> {
        return this.httpClient.get<any[]>(`${IBGE_API_PATH}localidades/estados`);
    }
}
